<template>
  <div>
        <div v-if="flag" id="ecommerce-wishlist-demo">
            <div data-v-16d3ec44="" class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class="center">هیچ آیتم علاقمندی ندارید.</h4>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="products && products.length>0">
            <div class="acr-global-product-controls">
                <div class="acr-product-active-filters">
                    <h6 id="productList" style="margin: 0"> {{count}} محصول یافت شد </h6>
                </div>
                <div class="acr-toggle-views d-none d-sm-block">
                    <a data-toggle="tooltip" @click="Styling('grid')" :class="{active: Style == 'grid'}" data-original-title="نمایش به صورت شبکه ای">
                        <i>
                            <svg viewBox="0 0 24 24" style="width:24px;height:24px">
                                <path fill="currentColor" d="M4,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H4C2.92,22 2,21.1 2,20V4A2,2 0 0,1 4,2M4,4V11H11V4H4M4,20H11V13H4V20M20,20V13H13V20H20M20,4H13V11H20V4Z"></path>
                            </svg>
                        </i>
                    </a>
                    <a data-toggle="tooltip" @click="Styling('row')" :class="{active: Style == 'row'}" data-original-title="نمایش به صورت لیست">
                        <i>
                            <svg viewBox="0 0 24 24" style="width:24px;height:24px">
                                <path fill="currentColor" d="M21,19V17H8V19H21M21,13V11H8V13H21M8,7H21V5H8V7M4,5V7H6V5H4M3,5A1,1 0 0,1 4,4H6A1,1 0 0,1 7,5V7A1,1 0 0,1 6,8H4A1,1 0 0,1 3,7V5M4,11V13H6V11H4M3,11A1,1 0 0,1 4,10H6A1,1 0 0,1 7,11V13A1,1 0 0,1 6,14H4A1,1 0 0,1 3,13V11M4,17V19H6V17H4M3,17A1,1 0 0,1 4,16H6A1,1 0 0,1 7,17V19A1,1 0 0,1 6,20H4A1,1 0 0,1 3,19V17Z"></path>
                            </svg>
                        </i>
                    </a>
                </div>
            </div>
            <!-- Products Start -->
            <div class="row">
                <div :class="{'col-xl-4 col-lg-6 col-md-6 col-sm-6': Style == 'grid', 'col-md-12': Style == 'row'}" v-for="(item,index) in list" :key="index">
                    <div v-if="item.product" class="product" :class="{'product-list': Style == 'row'}">
                        <div class="product-thumbnail" style="text-align: center;">
                            <a target="_blank" :href="`https://henzagold.shop/product/${item.product.title.split(' ').join('-')}/${item.product.id}`">
                                <img :src="list[index].product.image.image" alt="product" style="width: 190px;height: 190px;object-fit: scale-down">
                            </a>
<!--                            <div class="product-badges">
&lt;!&ndash;                                <span class="product-badge featured"> <i class="fas fa-star"></i></span>&ndash;&gt;
                                    <span class="product-badge" :class="[(false)?'sale' :'stock']">
                                        {{ list[index].product.product_code }}
                                    </span>
                            </div>-->
                            <div class="product-controls">
                              <a href="#" @click="removeFromWishList(item)" class="favorite">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
                                  <path fill="currentColor"
                                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                                </svg>
                              </a>
                              <!--                                <a href="#" class="compare"><i class="fas fa-sync-alt"></i></a>-->
<!--                                <a href="#" class="edit"><i class="fas fa-edit"></i></a>-->
<!--                                <a href="#" data-toggle="modal" data-target="#quickViewModal" class="quick-view"><i class="fas fa-eye"></i></a>-->
                            </div>
                        </div>
                        <div class="product-body" :class="{'center': Style == 'grid'}">
                            <div class="row">
                                <h5 class="product-title col-lg-12 col-xs-12" style="display:inline-block;">
                                    <a :href="`https://henzagold.shop/product/${item.product.title.split(' ').join('-')}/${item.product.id}`" target="_blank" :title="item.product.title">{{ list[index].product.title }}</a>
                                </h5>
                            </div>
<!--                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <span class="product-price">{{ list[index].Cost | priceUnit }} تومان</span>
                                </div>
                                <div class="col-lg-12 col-md-12"></div>
                            </div>-->
                            <div class="product-gallery-wrapper" style="margin-top:1rem">
<!--                                <a @click="addToCart(item)" class="btn-custom btn-sm secondary" style="cursor: pointer">افزودن به سبد خرید</a>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Products End -->
            <!-- Pagination Start -->
            <pagination
            v-model="page"
            :total-pages="Math.ceil(count/3)"
            @pagechanged="onPageChange" />
            <!-- Pagination End -->
        </div>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination";
// import Rate from "@/components/Rate.vue"
import axios from "@/plugins/axios";
export default {
    props:{
        togglePreLoader: Function
    },
    components: {
        // Rate,
        Pagination
    },
    data () {
        return {
            list: null,
            products: null,
            count: 0,
            page: 1,
            Style: 'grid',
            flag: false
        }
    },
    methods: {
      async removeFromWishList(item){
        await axios.delete(`cu/fav/${item.product_id}`)
        .then(()=>{
          this.getList()
          this.$vs.notify({time:3500,text:'محصول از لیست علاقمندی ها حذف شد',color:'var(--secondary-color)',icon:'check'})
        })
      },
        addToCart(item){
          let items = JSON.parse(localStorage.getItem("cart_items"))
          let index= this.$store.state.cart.items.findIndex((item)=>{
            if(item.item.pid==item.product.id)
              return true;
          });
          if(index === -1){
            items.push(item)
            localStorage.setItem("cart_items", JSON.stringify(items))
          }
        },
        getData(){
            var last = (this.page * 3)
            var first = last - 3
            this.list = this.products.slice(first, last)
        },
        Styling (Class) {
            this.Style = Class
        },
        onPageChange(){
            this.getData();
            let el = document.getElementById('productList')
            document.body.scrollTop = el.offsetTop - 150;
            document.documentElement.scrollTop = el.offsetTop - 150;
        },
      async getList(){
        try {
          this.togglePreLoader('open')
          let {data} = await axios.get("cu/fav")
          this.products = data
          this.count = data.length
          this.$store.dispatch("getWishList",data)
          if(this.products && this.products.length>0){
            this.getData()
          }
          else{
            this.flag = true
          }
        }
        catch (error) {
          if (error.response && error.response.data.errors) {
            let str_error = ''
            for(let item of Object.values(error.response.data.errors))
            {
              item.map(xx=>{
                if (xx.includes("shipping address")){
                  str_error += xx.replace("shipping address","آدرس") + "<br/>"
                }
                else{
                  str_error += xx + "<br/>"
                }
              })
            }
            this.$vs.notify({title:'خطایی رخ داد',time:3500,text:str_error,color:'var(--secondary-color)',icon:'error_outline'})
          }
          else{
            if (error) {
              if(error == "Error: Network Error"){
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:"اتصال برقرار نشد",color:'var(--secondary-color)',icon:'error_outline'})
              }
              else {
                this.$vs.notify({title:'خطایی رخ داد',time:3500,text:error,color:'var(--secondary-color)',icon:'error_outline'})
              }
            }
          }
        }
        finally {
          this.togglePreLoader('close')
        }
      }
    },
    created() {
        this.getList()
    }
}
</script>

<style>

</style>
